<template>
  <div
    class="uc-embed"
    uc-styling="true"
    :uc-embedding-type="embedType"
    :uc-show-toggle="serviceToggle"
  />
</template>

<script lang="ts" setup>
interface Props {
  embedType?: string;
  serviceToggle?: boolean;
}

withDefaults(defineProps<Props>(), {
  embedType: 'category',
  serviceToggle: false,
});
</script>
